import { render, staticRenderFns } from "./HighLifeNow.vue?vue&type=template&id=60887b6e&scoped=true&"
import script from "./HighLifeNow.vue?vue&type=script&lang=js&"
export * from "./HighLifeNow.vue?vue&type=script&lang=js&"
import style0 from "./HighLifeNow.vue?vue&type=style&index=0&id=60887b6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60887b6e",
  null
  
)

export default component.exports